module.exports = __webpack_public_path__ + "img/tooltip-team-image.4c756a0e.gif";